import { render, staticRenderFns } from "./KvmCopyable.vue?vue&type=template&id=0c474a18&scoped=true&"
import script from "./KvmCopyable.vue?vue&type=script&lang=js&"
export * from "./KvmCopyable.vue?vue&type=script&lang=js&"
import style0 from "./KvmCopyable.vue?vue&type=style&index=0&id=0c474a18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c474a18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c474a18')) {
      api.createRecord('0c474a18', component.options)
    } else {
      api.reload('0c474a18', component.options)
    }
    module.hot.accept("./KvmCopyable.vue?vue&type=template&id=0c474a18&scoped=true&", function () {
      api.rerender('0c474a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmCopyable.vue"
export default component.exports